/**
 * Fix para botones de tallas en mobile en secciones de productos complementarios
 * IMPORTANTE: Solo actúa en cards antiguos (.card-wrapper), NO en cards Enova
 */

// Interceptar clicks SOLO cuando el card ya está activo
document.addEventListener('click', function(e) {
  // NO interferir con los cards de Enova que tienen su propio sistema
  if (e.target.closest('.enova-product-card') || e.target.closest('.enova-product-list')) {
    return; // Salir y dejar que el sistema de Enova maneje el click
  }
  
  const cardWrapper = e.target.closest('.card-wrapper');
  
  // Si no hay card-wrapper, salir
  if (!cardWrapper) return;
  
  // Si el card ya está activo (tallas visibles)
  if (cardWrapper.classList.contains('is-mobile-active')) {
    const sizeButton = e.target.closest('.sizes-container--button');
    const colorButton = e.target.closest('.card__color-selector--color');
    const addButton = e.target.closest('.card__add-btn');
    
    // Si el click es en un botón de talla, color, o agregar
    if (sizeButton || colorButton || addButton) {
      // Prevenir que el evento burbujee al card-wrapper
      e.stopPropagation();
    }
  }
  // Si el card NO está activo, permitir que el click lo active (no hacer nada)
}, true); // Usar capture phase para interceptar ANTES que otros handlers

